import { useEffect, useState } from "react";
import type { LaunchMain } from "../models/launchDetail";
import { CommandGetLaunchDetail } from "../services/cmdGetLaunchDetail";

/** Answers by launch. The warehouse is frozen, so one stays good for the visit. */
const answers = new Map<string, Promise<LaunchMain | null>>();

/**
 * The launch's main record, for the summary strip and the Launch Lifetime range (MPN-2230).
 * `undefined` while loading, `null` when the warehouse has none or the read failed: the
 * strip is then simply not there.
 */
export function useLaunchMain(launchId: string): LaunchMain | null | undefined {
    const [main, setMain] = useState<LaunchMain | null | undefined>(launchId ? undefined : null);

    useEffect(() => {
        if (!launchId) {
            setMain(null);
            return;
        }
        let live = true;
        setMain(undefined);
        let answer = answers.get(launchId);
        if (!answer) {
            answer = new CommandGetLaunchDetail().run(launchId).then((detail) => detail?.main ?? null);
            answers.set(launchId, answer);
            answer.catch(() => answers.delete(launchId));
        }
        answer.then((result) => { if (live) setMain(result); }, () => { if (live) setMain(null); });
        return () => { live = false; };
    }, [launchId]);

    return main;
}
